module.exports = __webpack_public_path__ + "img/1b387f8.jpg";